export const SafeBridgeNewSearchTypesConstants = {
  SAFE_BRIDGE_AZURE_SEARCH: 'SAFE_BRIDGE_AZURE_SEARCH',
  LAST_SAFE_BRIDGE_SEARCH: 'LAST_SAFE_BRIDGE_SEARCH',
};
